import { createPermission } from '@backstage/plugin-permission-common';

/*
    KeyVault secrets permissions
*/
export const managementConfigsSecretsReadPermission = createPermission({
  name: 'managementconfigs.secrets.read',
  attributes: { action: 'read' },
});

export const managementConfigsSecretsShowValuePermission = createPermission({
  name: 'managementconfigs.secrets.show',
  attributes: { action: 'read' },
});

export const managementConfigsSecretsCreatePermission = createPermission({
  name: 'managementconfigs.secrets.create',
  attributes: { action: 'create' },
});

export const managementConfigsSecretsDeletePermission = createPermission({
  name: 'managementconfigs.secrets.delete',
  attributes: { action: 'delete' },
});

export const managementConfigsPermissions = [
  managementConfigsSecretsReadPermission,
  managementConfigsSecretsShowValuePermission,
  managementConfigsSecretsCreatePermission,
  managementConfigsSecretsDeletePermission,
];
